import { execSync } from 'child_process'
import inquirer from 'inquirer'

module.exports.execSync = (cmd, newOptions = {}) => {
  const defaultOptions = {
    stdio: 'pipe',
  }
  const options = Object.assign(defaultOptions, newOptions)
  const result = execSync(cmd, options)
  if (result !== null) {
    return result.toString()
  }
  return result
}

module.exports.Separator = inquirer.Separator

module.exports.prompt = (options) => {
  return inquirer.prompt(options)
}

module.exports.promptList = (name, message, choices) => {
  const options = [{
    type: 'list',
    name: name,
    message: message,
    choices: choices,
  }]
  return inquirer.prompt(options)
}

module.exports.promptConfirm = (message, defaultValue = true) => {
  const options = [{
    type: 'confirm',
    name: 'confirm',
    message: message,
    default: defaultValue,
  }]
  return inquirer.prompt(options)
}
